(function () {
  var TOL = 2;

  function measureGap(el) {
    var g = window.getComputedStyle(el).gap;
    if (g && g !== 'normal') {
      var n = parseFloat(g);
      return isNaN(n) ? 8 : n;
    }
    return 8;
  }

  /** Ancho de las primeras n pastillas + gaps (redondeo) */
  function widthForFirstN(list, n) {
    var items = list.querySelectorAll('.plp-nav-bar__item');
    if (!items.length) return 0;
    var take = Math.min(n, items.length);
    var gap = measureGap(list);
    var sum = 0;
    for (var i = 0; i < take; i++) {
      sum += items[i].getBoundingClientRect().width;
      if (i < take - 1) sum += gap;
    }
    return Math.ceil(sum);
  }

  /** Cuántas pastillas entran en maxWidth px (al menos 1 si hay ítems). */
  function countFittingItems(list, maxWidth) {
    var items = list.querySelectorAll('.plp-nav-bar__item');
    if (!items.length || maxWidth <= 0) return 1;
    var gap = measureGap(list);
    var sum = 0;
    for (var i = 0; i < items.length; i++) {
      var w = items[i].getBoundingClientRect().width;
      var need = i === 0 ? w : sum + gap + w;
      if (need > maxWidth + 0.5) return Math.max(1, i);
      sum = need;
    }
    return items.length;
  }

  function scrollTarget(strip) {
    return strip.querySelector('.plp-nav-bar__viewport');
  }

  function syncArrows(strip, viewport) {
    var prev = strip.querySelector('.plp-nav-bar__arrow--prev');
    var next = strip.querySelector('.plp-nav-bar__arrow--next');
    if (!prev || !next || !viewport) return;
    var max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    prev.disabled = viewport.scrollLeft <= TOL;
    next.disabled = viewport.scrollLeft >= max - TOL;
  }

  function layout(strip) {
    var viewport = scrollTarget(strip);
    if (!viewport) return;
    var list = viewport.querySelector('.plp-nav-bar__list');
    if (!list) return;
    var prev = strip.querySelector('.plp-nav-bar__arrow--prev');
    var next = strip.querySelector('.plp-nav-bar__arrow--next');
    var items = list.querySelectorAll('.plp-nav-bar__item');
    var count = items.length;

    viewport.style.width = '';

    if (prev) {
      prev.hidden = true;
      prev.disabled = true;
    }
    if (next) {
      next.hidden = true;
      next.disabled = true;
    }
    strip.classList.remove('plp-nav-bar__strip--with-arrows');

    if (count === 0) return;

    var stripWidth = strip.getBoundingClientRect().width;
    var listWidth = list.scrollWidth;

    if (listWidth <= stripWidth + TOL) {
      syncArrows(strip, viewport);
      return;
    }

    strip.classList.add('plp-nav-bar__strip--with-arrows');
    if (prev) prev.hidden = false;
    if (next) next.hidden = false;

    function applyViewportBetweenArrows() {
      var prevW = prev ? prev.getBoundingClientRect().width : 0;
      var nextW = next ? next.getBoundingClientRect().width : 0;
      var g = measureGap(strip);
      var avail = Math.max(0, Math.floor(strip.getBoundingClientRect().width - prevW - nextW - 2 * g));
      viewport.style.width = avail + 'px';
      syncArrows(strip, viewport);
    }

    requestAnimationFrame(applyViewportBetweenArrows);
  }

  function scrollActiveIntoView(strip) {
    var viewport = scrollTarget(strip);
    if (!viewport) return;
    var active = viewport.querySelector('.plp-nav-bar__link--active');
    if (!active) return;
    var li = active.closest('.plp-nav-bar__item');
    if (!li || typeof li.scrollIntoView !== 'function') return;
    li.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'auto' });
  }

  function bindStrip(strip) {
    var viewport = scrollTarget(strip);
    if (!viewport || strip.getAttribute('data-plp-nav-bound') === '1') return;
    strip.setAttribute('data-plp-nav-bound', '1');

    var prev = strip.querySelector('.plp-nav-bar__arrow--prev');
    var next = strip.querySelector('.plp-nav-bar__arrow--next');

    function onScroll() {
      syncArrows(strip, viewport);
    }

    viewport.addEventListener('scroll', onScroll, { passive: true });

    function stepAmount() {
      var listEl = viewport.querySelector('.plp-nav-bar__list');
      if (!listEl) return Math.max(40, Math.floor(viewport.clientWidth * 0.85));
      var n = countFittingItems(listEl, viewport.clientWidth);
      return Math.max(1, widthForFirstN(listEl, n));
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        viewport.scrollBy({ left: -stepAmount(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        viewport.scrollBy({ left: stepAmount(), behavior: 'smooth' });
      });
    }

    var ro = window.ResizeObserver
      ? new ResizeObserver(function () {
          layout(strip);
          scrollActiveIntoView(strip);
          syncArrows(strip, viewport);
        })
      : null;
    if (ro) {
      ro.observe(viewport);
      ro.observe(strip);
    }

    window.addEventListener(
      'resize',
      function () {
        layout(strip);
        scrollActiveIntoView(strip);
        syncArrows(strip, viewport);
      },
      { passive: true }
    );

    layout(strip);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        layout(strip);
        scrollActiveIntoView(strip);
        syncArrows(strip, viewport);
      });
    });
  }

  function init() {
    document.querySelectorAll('.plp-nav-bar__strip').forEach(bindStrip);
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target;
    if (!root || !root.querySelector || !root.querySelector('.plp-nav-bar')) return;
    root.querySelectorAll('.plp-nav-bar__strip').forEach(function (strip) {
      strip.removeAttribute('data-plp-nav-bound');
    });
    root.querySelectorAll('.plp-nav-bar__strip').forEach(bindStrip);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  setTimeout(init, 200);
})();
